import { render, staticRenderFns } from "./baseInfoCheck.vue?vue&type=template&id=edcf5c6a"
import script from "./baseInfoCheck.vue?vue&type=script&lang=js"
export * from "./baseInfoCheck.vue?vue&type=script&lang=js"
import style0 from "./baseInfoCheck.vue?vue&type=style&index=0&id=edcf5c6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports